import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';

export class DeskFrontToSimpleSapElementMapper
    extends BaseElementToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const dim2 = element.shape.x;
        const type = this.formatType('FRS', 7, dim2);
        const color = this.toColor(element);
        return [SimpleSapElement.ELEMENT(type, color)];
    }
}